module.exports = __webpack_public_path__ + "static/favicon-06c3fde68e8ffd8895d32feb3bea43a2.ico";